export function buildTemplateButtonStates({
  hasDraftBlockingErrors = false,
  hasPublishBlockingErrors = false,
  hasTemplateNameBlockingError = false,
  hasSendConditionsBlockingError = false,
  isSubmitting = false,
  isSourceDataLoading = false,
  hasTemplateId = false,
  isAlreadyPublished = false,
  hasUnsavedChanges = false,
  // Create-only tenant gating: empty selection blocks Save/Publish; a non-own tenant restricts
  // to a draft (Publish off). Deactivate is edit-only, so neither flag reaches it.
  tenantRequiredActive = false,
  restrictToDraft = false,
}) {
  const isBusy = isSubmitting || isSourceDataLoading;

  return {
    isSaveDisabled: hasDraftBlockingErrors || isBusy || tenantRequiredActive,
    isDeactivateDisabled: hasDraftBlockingErrors || isBusy || !hasTemplateId,
    isPublishDisabled:
      hasPublishBlockingErrors ||
      hasTemplateNameBlockingError ||
      hasSendConditionsBlockingError ||
      isBusy ||
      (isAlreadyPublished && !hasUnsavedChanges) ||
      tenantRequiredActive ||
      restrictToDraft,
  };
}
